import ReactTooltip from 'react-tooltip';

import * as S from './Tooltip.styles';

type TooltipProps = {
  content?: string;
  place?: 'top' | 'right' | 'left' | 'bottom';
  effect?: 'float' | 'solid';
  html?: boolean;
  children?: React.ReactNode;
};

const defaultProps: Partial<TooltipProps> = {
  place: 'top',
  effect: 'float',
  content: undefined,
  html: false,
  children: undefined,
};

export function Tooltip(props: TooltipProps): React.ReactElement {
  const { content, place, effect, html, children } = { ...defaultProps, ...props };

  return (
    <>
      <span data-tip={content}>{children || <S.Trigger name="FiHelpCircle" />}</span>

      <ReactTooltip place={place} type="dark" effect={effect} html={html} />
    </>
  );
}
